import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withLastLocation } from 'react-router-last-location';

import * as actions from 'store/services/testSets/actions';
import * as selectors from 'store/services/testSets/selectors';
import { getSidebarIsOpen } from 'store/services/settings/selectors';
import {
  getProject,
  getProjectIsLoading,
} from 'store/services/project/selectors';

import FileSystem from 'components/FileSystem';

export const TestSetsEditor = ({
  // List props
  count,
  currentPage,
  listItems,
  isLoadingList,
  isUploading,
  uploadingFilesList,
  hasUploadingFilesError,
  listSearchTerm,
  sidebarIsOpen,
  getFiles,
  addNewFile,
  addFile,
  updateFile,
  updatedSearchTerm,
  openFile,
  uploadFiles,
  resetUploadFiles,
  deleteFiles,
  exportFiles,
  deleteFile,
  exportFile,
  openFiles,
  // Current project
  project,
  projectIsLoading,
  // From withLastLocation
  lastLocation,
  // React router
  location,
  // Editor props
  isLoadingEditor,
  isSaving,
  theme,
  editorSearchTerm,
  selectedFile,
  selectedFiles,
  closeEditorFile,
  setTheme,
  updateEditorSearchTerm,
  updateBlob,
  updateFiles,
}) => (
  <FileSystem
    addFile={addFile}
    addNewFile={addNewFile}
    closeEditorFile={closeEditorFile}
    count={count}
    currentPage={currentPage}
    deleteFile={deleteFile}
    deleteFiles={deleteFiles}
    editorSearchTerm={editorSearchTerm}
    exportFile={exportFile}
    exportFiles={exportFiles}
    getFiles={getFiles}
    hasUploadingFilesError={hasUploadingFilesError}
    isLoadingEditor={isLoadingEditor}
    isLoadingList={isLoadingList}
    isSaving={isSaving}
    isUploading={isUploading}
    lastLocation={lastLocation}
    listItems={listItems}
    listSearchTerm={listSearchTerm}
    location={location}
    modelName="testSetsEditor"
    openFile={openFile}
    openFiles={openFiles}
    project={project}
    projectIsLoading={projectIsLoading}
    resetUploadFiles={resetUploadFiles}
    selectedFile={selectedFile}
    selectedFiles={selectedFiles}
    setTheme={setTheme}
    sidebarIsOpen={sidebarIsOpen}
    theme={theme}
    updateBlob={updateBlob}
    updatedSearchTerm={updatedSearchTerm}
    updateEditorSearchTerm={updateEditorSearchTerm}
    updateFile={updateFile}
    updateFiles={updateFiles}
    uploadFiles={uploadFiles}
    uploadingFilesList={uploadingFilesList}
  />
);

TestSetsEditor.propTypes = {
  ...FileSystem.propTypes,
};

const mapStateToProps = state => ({
  count: selectors.getCount(state),
  currentPage: selectors.getCurrentPage(state),
  listItems: selectors.getFilteredFiles(state),
  listSearchTerm: selectors.getSearchTerm(state),
  editorSearchTerm: selectors.getEditorSearchTerm(state),
  sidebarIsOpen: getSidebarIsOpen(state),
  theme: selectors.getTheme(state),
  selectedFile: selectors.getEditorCurrentFile(state),
  selectedFiles: selectors.getEditorFiles(state),
  isSaving: selectors.getIsSaving(state),
  isLoadingEditor: selectors.getIsEditorLoading(state),
  isLoadingList: selectors.getIsLoading(state),
  isUploading: selectors.getIsUploading(state),
  uploadingFilesList: selectors.getUploadingFiles(state),
  hasUploadingFilesError: selectors.getHasUploadingFilesError(state),
  // Current project
  project: getProject(state),
  projectIsLoading: getProjectIsLoading(state),
});

const mapDispatchToProps = dispatch => ({
  openFile: bindActionCreators(actions.openFile, dispatch),
  closeEditorFile: bindActionCreators(actions.closeEditorFile, dispatch),
  setTheme: bindActionCreators(actions.setTheme, dispatch),
  updateBlob: bindActionCreators(actions.updateBlob, dispatch),
  updateEditorSearchTerm: bindActionCreators(
    actions.updateEditorSearchTerm,
    dispatch,
  ),
  getFiles: bindActionCreators(actions.getFiles, dispatch),
  updateFiles: bindActionCreators(actions.updateFiles, dispatch),
  addNewFile: bindActionCreators(actions.addNewFile, dispatch),
  addFile: bindActionCreators(actions.addFile, dispatch),
  updateFile: bindActionCreators(actions.updateFile, dispatch),
  updatedSearchTerm: bindActionCreators(actions.updatedSearchTerm, dispatch),
  uploadFiles: bindActionCreators(actions.uploadFiles, dispatch),
  resetUploadFiles: bindActionCreators(actions.resetUploadFiles, dispatch),
  deleteFiles: bindActionCreators(actions.deleteFiles, dispatch),
  exportFiles: bindActionCreators(actions.exportFiles, dispatch),
  deleteFile: bindActionCreators(actions.deleteFile, dispatch),
  exportFile: bindActionCreators(actions.exportFile, dispatch),
  openFiles: bindActionCreators(actions.openFiles, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLastLocation,
)(TestSetsEditor);
